/**
 * Build the public request used by both the homepage preview and the full
 * On Sale pre-sale list.
 *
 * @param {{pageSize: number, page?: number, category?: string, sortBy?: string, direction?: string}} options
 */
export function buildUpcomingSaleRequest({
  pageSize,
  page = 1,
  category,
  sortBy,
  direction
}) {
  return {
    url: "/products/pre-sale",
    queries: { pageSize, page, category, sortBy, direction }
  }
}
